<template>
  <div class="content">
    <div class="cardContent">
      <div class="kxq">
        <div class="rowClass">
          <p>
            <span class="span-l">ICCID:</span><span class="span-r">{{cardData.iccid}}</span>
          </p>
          <p>
            <span class="span-l">IMSI:</span><span class="span-r">{{cardData.imsi}}</span>
          </p>
          <p>
            <span class="span-l">代理商:</span><span class="span-r">{{cardData.company}}</span>
          </p>
          <p>
            <span class="span-l">{{cardData.name}}:</span>
            <span class="span-r span-refresh">{{cardData.cardStatus}}</span>
          </p>
          <p>
            <span class="span-l">状态:</span><span class="span-r">{{cardData.showStatus}}</span>
          </p>
          <p>
            <span class="span-l">运营商:</span>
            <span class="span-r">{{cardData.operationName}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">卡源:</span><span class="span-r">{{cardData.cardSourceName}}</span>
          </p>
          <p>
            <span class="span-l">当月流量:</span>
            <span class="span-r span-refresh">{{cardData.monthFlow}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">开户时间:</span><span class="span-r">{{cardData.openTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">分配时间:</span><span class="span-r">{{cardData.lastAdminTransferTime}}</span>
          </p>
          <p v-if="adminShow">
            <span class="span-l">销户时间:</span><span class="span-r">{{cardData.delTime}}</span>
          </p>
          <p>
            <span class="span-l">套餐激活时间:</span><span class="span-r">{{cardData.activeTime}}</span>
          </p>
          <p>
            <span class="span-l">套餐过期时间:</span><span class="span-r">{{cardData.expireTime}}</span>
          </p>
        </div>
        <div class="aloneClass">
          <p v-if="adminShow"><span class="span-l">层级显示：</span><span class="span-r">{{cardData.companyNameLevel}}</span></p>
          <p>
            <span class="span-l">备注显示：</span>
            <span class="span-r">{{cardData.remark}}
              <span style="position: relative;top: -5px;cursor: pointer;" v-if="adminShow">
                <i class="el-icon-edit bianji-class" @click="editRow()"></i>
              </span>
            </span>
          </p>
          <p v-if="!adminShow">
            <el-button type="success" size="medium" v-hasPermi="['card:info:refresh']"  @click="refreshNow()">立即刷新</el-button>
          </p>
        </div>
        <div class="operation-class">
          <el-button type="success" size="medium" v-hasPermi="['card:info:refresh']"  @click="updateNow()" v-if="adminShow">立即更新</el-button>
        </div>
      </div>
    </div>
    <div class="cardContent marge-class">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="流量资费列表" name="second"  v-if="checkPermi(['card:info:cardProduct'])">
          <cardInternationalProduct ref="cardJftcRef" :iccid="iccid"></cardInternationalProduct>
        </el-tab-pane>
        <el-tab-pane label="订单列表" name="third" v-if="checkPermi(['card:info:orderList'])">
          <cardOrderList ref="cardOrderListRef" :iccid="iccid"></cardOrderList>
        </el-tab-pane>
        <el-tab-pane label="操作列表" name="fourth" v-if="checkPermi(['card:info:operationList'])">
          <operationList ref="operationListRef" :iccid="iccid"></operationList>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="备注" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="beizhu" ref="beizhu">
        <el-form-item label="备注内容:" prop="remark" label-width="100px">
          <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
        </el-form-item>
        <el-form-item label="售后内容:" prop="saleRemark" label-width="100px">
          <el-input type="textarea" v-model="beizhu.saleRemark" autocomplete="off" style="width: 80%" placeholder="请输入售后内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import cardInternationalProduct from "@/components/cardDetails/cardInternationalProduct.vue";
import cardOrderList from "@/components/cardDetails/cardOrderList.vue";
import operationList from "@/components/cardDetails/operationList.vue";

import {
  cardDetail,
  syncRefreshMonthFlow,
  syncRefreshOnline
} from "@/api/api.js"; //卡详情的初始化数据
import { cleanPhone } from "@/api/api.js";//重置手机号
import { changeCardSyncStatus } from "@/api/api.js";//修改同步状态
import { syncCard } from "@/api/api.js";//立即更新
import { saveRemark } from "@/api/api.js"; //流量卡备注

export default {
  // name:'carddetail',
  data() {
    return {
      iccid : undefined,
      activeName: "second",
      cardLock:"未知",
      cardData:{},
      dialog:false,
      beizhu:{
        remark:"",
        saleRemark:""
      },
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    }
  },
  components: {
    cardInternationalProduct,
    cardOrderList,
    operationList,
  },
  methods: {
    handleClick(tab) {
      if (tab.name == "second") {
        this.$refs.cardJftcRef.initData();
      }else if(tab.name == "third"){
        this.$refs.cardOrderListRef.initData();
      }else if(tab.name == "fourth"){
        this.$refs.operationListRef.initData();
      }else if(tab.name == "fifth"){
        this.$refs.remarkListRef.initData();
      }else if(tab.name == "eighth"){
        this.$refs.cardIntegralListRef.initData();
      }else if(tab.name == "smsProduct"){
        this.$refs.cardSmsProduct.initData();
      }else if(tab.name == "ninth"){
        this.$refs.diagnosticResultsRef.initData();
      }
    },
    transferFlowRatio(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    Realnamestatus(status) {
      let obj = {
        0: "未实名 ",
        1: "实名中",
        2: "已实名",
        3: "未通过",
        4: "已注销",
      };
      return obj[status];
    },
    // 初始化数据
    initData() {
      let params ={
        iccid : this.iccid
      }
      cardDetail(params).then(res => {
        if(res.data.code == 200){
          this.cardData = res.data.data;
          this.cardData.kycStatus = this.Realnamestatus(this.cardData.kycStatus);
          this.cardData.sync = this.cardData.sync == "开启" ? "已开启" : "未开启";
          this.cardData.gprsStatus = this.cardData.gprsStatus == "开启" ? "已开启" : "未开启";
          this.cardData.speedStatus = this.cardData.speedStatus == 0 ? "未限速" : "已限速";
          this.cardData.monthFlow = this.cardData.monthFlow == null ? "无" : this.cardData.monthFlow + "M";
          this.cardData.remark = this.cardData.remark == null || this.cardData.remark == "" ? "无" : this.cardData.remark;
          this.cardData.openTime = this.cardData.openTime == null ? "无" : this.cardData.openTime;
          this.cardData.lastAdminTransferTime = this.cardData.lastAdminTransferTime == null ? "无" : this.cardData.lastAdminTransferTime;
          this.cardData.delTime = this.cardData.delTime == null ? "无" : this.cardData.delTime;
          this.cardData.activeTime = this.cardData.activeTime == null ? "无" : this.cardData.activeTime;
          this.cardData.expireTime = this.cardData.expireTime == null ? "无" : this.cardData.expireTime;
          this.cardData.phone = this.cardData.phone == null || this.cardData.phone == "" ? "无" : this.cardData.phone;
          this.cardData.company = this.cardData.company == null ? "未分配" : this.cardData.company;
          this.cardData.companyNameLevel = this.cardData.companyNameLevel == null ? "未分配" : this.cardData.companyNameLevel;
          this.cardData.imei = this.cardData.imei == null ? "无" : this.cardData.imei;
          this.cardData.hasAgreement = this.cardData.hasAgreement == 0 ? "未签约" : "已签约";
          switch (this.cardData.online) {
            case "online":
              this.cardData.online = "在线";
              break;
            case "offline":
              this.cardData.online = "不在线";
              break;
            case "unknown":
              this.cardData.online = "未查询到会话信息";
              break;
            case null:
              this.cardData.online = "未查询";
              break;
          }
          // 运营状态--运营商状态真的
          // 状态--公众号展示状态假的
          if(this.adminShow){
            this.cardData.name = '运营状态';
            this.cardData.cardStatus = this.transferFlowRatio(this.cardData.cardStatus);
            this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
          }else{
            this.cardData.showStatus = this.transferFlowRatio(this.cardData.showStatus);
            this.cardData.name = 'IMSI';
            this.cardData.cardStatus = "无";
            this.cardData.cardSourceName = "无";
            this.cardData.gprsStatus = "已开启";
            if(this.cardData.hasEnjoy == "1"){
              this.cardData.monthFlow = "畅享"
            }
          };
        }
      })
    },
    // 备注的弹窗
    editRow(){
      this.dialog = true;
      this.beizhu ={};
      this.$set(this.beizhu,"remark",this.cardData.remark)
    },
    // 备注弹窗x
    dialogClose(){
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    // 备注的取消按钮
    cancelDialog(){
      this.dialog = false;
    },
    // 备注的确认按钮
    saveDialog(){
      let params = {
        iccid:this.cardData.iccid,
        remark:this.beizhu.remark,
        saleRemark:this.beizhu.saleRemark
      };
      saveRemark(params).then(res =>{
        if (res.data.code == 200) {
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData();
        }
      })
    },
    // 重置手机号
    resetPhone(){
       this.$confirm('是否继续重置手机号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          iccid : this.iccid
        }
        cleanPhone(params).then(res => {
          this.$message({
              type: 'success',
              message: '重置成功!'
            });
          this.initData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });          
      });
    },
    // 开关同步
    synchro(){
      let params = {
        iccid:this.iccid
      };
      if(this.cardData.sync == "已开启"){
        params.syncStatus = 0;
        changeCardSyncStatus(params).then(res =>{
          this.$message({
              message: '关闭同步成功',
              type: 'success'
            });
          this.initData();
        })
      }else{
        params.syncStatus = 1;
        changeCardSyncStatus(params).then(res =>{
          this.$message({
              message: '开启同步成功',
              type: 'success'
            });
          this.initData();
        })
      }
    },
    // 立即更新
    updateNow(){
      let params = {
        iccid:this.iccid
      }
      syncCard(params).then(res =>{
        this.$message({
            message: '立即更新成功',
            type: 'success'
          });
        this.initData();
      })
    },
    //刷新当月流量
    refreshMonthFlow() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshMonthFlow(params).then((res) => {
        this.$message({
          message: "刷新当月流量成功",
          type: "success",
        });
        this.initData();
      });
    },
    //刷新在线状态
    refreshOnline() {
      let params = {
        iccid: this.cardData.iccid,
      };
      syncRefreshOnline(params).then((res) => {
        this.$message({
          message: "刷新在线状态成功",
          type: "success",
        });
        this.initData();
      });
    },
    //刷新诊断结果
    refreshDiagnosticResults(){
      this.activeName = "ninth";
      this.$refs.diagnosticResultsRef.refreshDiagnosticData();
    },
  },
  beforeRouteUpdate(to, from, next) {
    if(to.name == 'carddetail' && to.query && to.query.iccid){
      this.iccid =  to.query && to.query.iccid;
      this.initData();
      this.activeName = "second";
      this.$refs.cardJftcRef.changeIccid(this.iccid);
      this.$refs.cardJftcRef.initData();
    }
    next();
  },
  created() {
    this.iccid =  this.$route.query && this.$route.query.iccid;
    this.initData();
  },
  mounted() {
    if(!this.checkPermi(['card:info:cardProduct'])){
        this.activeName = 'smsProduct';
    } 
  },
};
</script>
<style scoped lang="less">
  .cardContent{
    padding: 0 20px;
  }
  .kxq{
    width: 100%;
    .rowClass{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      p{
        width: 33.3%;
        padding: 8px 0;
      }
    }
      .span-l{
        display: inline-block;
        width: 30%;
        text-align: left;
        font-size: 14px;
        color: #606266;
      }
      .span-r{
        display: inline-block;
        width: 70%;
        font-size: 14px;
        color: #1890ff;
      }
      .span-refresh{
        width: auto;
      }
      .span-refresh-btn{
        margin-left: 6px;
        font-size: 1.25rem;
        color: #67C23A;
      }
      .span-lock-unlock{
        font-size: 1.25rem;
        margin-left: 8px;
        color: #F56C6C;
      }
  }
  .aloneClass{
    p{
      padding: 8px 0;
    }
    .span-l{
      display: inline-block;
      width: 10%;
      text-align: left;
      font-size: 14px;
      color: #606266;
    }
    .span-r{
      display: inline-block;
      width: 90%;
      font-size: 14px;
      color: #1890ff;
    }
  }
  .operation-class{
    margin-top: 18px;
  }
  .marge-class{
    margin-top: 18px;
    padding-bottom:40px ;
  }
  @media screen and (max-width: 750px){
    .rowClass p{
      width: 100% !important;
    }
    .aloneClass p{
      .span-l{
        width: 30%;
      }
      .span-r{
        margin-left:10px
      }
    }
    .operation-class{
      .anniu{
        margin-left: 10px;
      }
      button{
        display: block;
        margin-top: 10px;
      }
    }
  }
  @media screen and (min-width: 750px) and (max-width: 1310px){
    .rowClass p{
      width: 50% !important;
    }
    .aloneClass p{
      .span-l{
        width: 15% !important;
      }
      .span-r{
        width:85% !important;
      }
    }
  }
</style>  